import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import { PageLoader } from "../../../shared_elements";
import ErrorPopUp from "../../../shared_elements/ErrorPopUp";
import { Autocomplete } from "@material-ui/lab";

const AddEditAircraftModels = ({ params, toggleModalFn, addEditAircraftModels, getResponseBack, modeType, aircraftTypeInfo }) => {
    const [data, setData] = useState(addEditAircraftModels?.data);
    const [error, setError] = useState({ modal: false, data: null })
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value })
    }

    const isDataChanged = () => {
        const originalData = addEditAircraftModels?.data || {};
        return(
            data?.name !== originalData?.name ||
            data?.remarks !== originalData?.remarks ||
            data?.aircraft_type !== originalData?.aircraft_type
        )
    }

    const onAddEditAircraftModels = () => {
        let validationInputs = {
            name: data?.name?.trim() ? '' : 'Please enter Aircraft Model Name',
            aircraft_type: data?.aircraft_type ? '' : 'Please select Aircraft Type',
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            
            let payload = Object.assign({}, data);
            
            payload = {
                id:payload?.id ? payload?.id : null,
                name: payload?.name ? payload?.name : null,
                ac_types: payload?.ac_types ? payload?.ac_types : null,
                remarks: payload?.remarks ? payload?.remarks : null,
                aircraft_type: payload?.aircraft_type?.id ? payload?.aircraft_type?.id : payload?.aircraft_type ?payload?.aircraft_type : null,
            }
            
            const apiUrl = data?.id ? `config-data/aircraft-model/bulk-update/` : `config-data/aircraft-model/`;
            const apiMethod = data?.id ? globalPutService : globalPostService;
            apiMethod(apiUrl, [payload])
                .then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        toggleModalFn();
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Aircraft Models Data Updated Successfully' : 'Aircraft Models Data Added Successfully',
                            page_title: 'Config Data : Aircraft Models',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    } else {
                        getResponseBack();
                        setError({ modal: true, data: response?.data?.error_details })
                        setLoading(false);
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Aircraft Models Updated Failed' : 'Aircraft Models Data Added Failed',
                            page_title: 'Config Data : Aircraft Models',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            item_id: data?.id || null,
                            error_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    }
                })
        } else {
            setError(validationInputs);
        }
    }
    return (
        <>
            <Dialog
                open={true}
                className='console-management-modal'
            >
                <DialogTitle id="scroll-dialog-title">
                    {modeType === 'edit' ? 'Edit' : modeType === 'view' ? 'Veiw' : 'Add'} Aircraft Model
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item md={12}>
                                <TextField
                                    name='name'
                                    label='Name'
                                    disabled={modeType === 'view'}
                                    required
                                    value={data?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 150 }}
                                    onChange={(e) => onFieldChange('name', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.name || ''}
                                    helperText={error?.name || ''}
                                    onFocus={() => setError({ ...error, name: '' })}
                                />
                            </Grid>
                             {modeType === "view" ? <Grid item md={12}>
                                <TextField
                                    name='Linked A/C Types'
                                    label='Linked A/C Types'
                                    disabled
                                    value={data?.ac_type?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid> : null }
                            <Grid item md={12} >
                                <Autocomplete
                                    options={aircraftTypeInfo}
                                    getOptionLabel={option => option?.name || ''}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="aircraft_type"
                                    disabled={modeType === 'view'}
                                    value={aircraftTypeInfo.find(item => item.id == data.aircraft_type ) || null}
                                    onChange={(e, value) => onFieldChange('aircraft_type', value?.id)}
                                    renderInput={params => <TextField placeholder={'Please select Aircraft Type'}  {...params} label={'Aircraft Type'} error={error?.aircraft_type || ''} helperText={error?.aircraft_type || ''} margin="normal" required fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    onFocus={() => setError({ ...error, aircraft_type: '' })}
                                />
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled={modeType === 'view'}
                                    value={data?.remarks || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={3}
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('remarks', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Models', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${modeType === 'add' ? 'Add' : modeType === 'view' ? 'View' : 'Edit'} Aircraft Models form` }) }} color='primary' size='small' variant='outlined'>{modeType === 'view' ? 'Close' : 'Cancel'}</Button>
                    {modeType === 'view' ? null : <Button onClick={() => { onAddEditAircraftModels(); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Models', item_type: 'Save Button', event_type: 'Item Clicked', event_desc: `Clicked on Save Button from ${modeType === 'add' ? 'Add' : 'Edit'} Aircraft Models form` }) }} disabled={isLoading || (modeType === 'edit' && !isDataChanged())} color='primary' size='small' variant='contained'>{isLoading ? <CircularProgress size={24} /> : 'Save'}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
            {error?.data?.map((item) =>
                <ErrorPopUp
                    toggleModalFn={() => setError({ modal: false, data: null })}
                    modal={error.modal}
                    error={item}
                />)}
        </>
    )
}
export default AddEditAircraftModels;